import { useState } from "react";
import { memberApi } from "../../lib/api";
import { toast } from "sonner";

// Vidéos de répétitions (liens YouTube non répertoriée / Drive / iCloud…) que le Kru regarde avant l'évaluation.
export function RepVideos({ code, videos, beltGroups, onChanged }) {
  const [url, setUrl] = useState("");
  const [tech, setTech] = useState("");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);
  const add = async () => {
    if (!url.trim()) return;
    setBusy(true);
    try { await memberApi.post("/member/academy/videos", { discipline: code, url: url.trim(), technique_id: tech, note }); toast.success("Vidéo jointe — le Kru la regardera avant ton évaluation."); setUrl(""); setNote(""); setTech(""); onChanged?.(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Lien invalide"); } finally { setBusy(false); }
  };
  const del = async (id) => { try { await memberApi.delete(`/member/academy/videos/${id}`); onChanged?.(); } catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); } };
  return (
    <div className="border border-white/10 p-3 text-xs space-y-2" data-testid="rep-videos">
      <p className="text-[#C9A961] uppercase tracking-wider text-[10px]">🎬 Mes vidéos de répétitions</p>
      <p className="text-white/55">Filme une courte séquence (30 s à 2 min), mets-la en ligne (YouTube « non répertoriée », Google Drive, iCloud, Dropbox…) et colle le lien ici. Le Kru la regarde avant ton évaluation.</p>
      <div className="grid sm:grid-cols-[1fr_auto] gap-2">
        <input value={url} onChange={(e) => setUrl(e.target.value)} placeholder="https://youtu.be/…  ou lien Google Drive" className="bg-black border border-white/20 px-2 py-1.5 text-white" data-testid="rep-video-url" />
        <select value={tech} onChange={(e) => setTech(e.target.value)} className="bg-black border border-white/20 px-2 py-1.5 text-white" data-testid="rep-video-technique">
          <option value="">Technique (optionnel)…</option>
          {(beltGroups || []).map((g) => <optgroup key={g.belt} label={`Ceinture ${g.belt}`}>{g.techniques.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}</optgroup>)}
        </select>
      </div>
      <div className="flex gap-2">
        <input value={note} onChange={(e) => setNote(e.target.value)} maxLength={300} placeholder="Note pour le Kru (optionnel)" className="flex-1 bg-black border border-white/20 px-2 py-1.5 text-white" data-testid="rep-video-note" />
        <button onClick={add} disabled={busy || !url.trim()} className="bg-[#C9A961] text-black font-semibold px-3 py-1.5 disabled:opacity-40" data-testid="rep-video-add">{busy ? "…" : "Joindre"}</button>
      </div>
      {(videos || []).length > 0 && (
        <ul className="space-y-1" data-testid="rep-video-list">
          {videos.map((v) => (
            <li key={v.id} className="flex flex-wrap items-center gap-2 border border-white/10 bg-black/40 px-2 py-1.5" data-testid={`rep-video-${v.id}`}>
              <a href={v.url} target="_blank" rel="noreferrer" className="text-[#C9A961] underline truncate max-w-[260px]">{v.url}</a>
              <span className="text-white/50">{String(v.created_at).slice(0, 10)}{v.technique_name ? ` · ${v.technique_name}` : ""}{v.note ? ` · ${v.note}` : ""}</span>
              {v.reviewed_at ? <span className="ml-auto text-emerald-300" data-testid={`rep-video-reviewed-${v.id}`}>✔ Vue par le Kru{v.kru_comment ? ` : « ${v.kru_comment} »` : ""}</span>
                : <button onClick={() => del(v.id)} className="ml-auto text-white/30 hover:text-rose-400" data-testid={`rep-video-del-${v.id}`}>✕</button>}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
